import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Customer } from "../../types/customer";
import { getCustomersApi } from "../../api/customersApi";

interface CustomerState {
  customers: Customer[];
  loading: boolean;
  error: string | null;
}

const initialState: CustomerState = {
  customers: [],
  loading: false,
  error: null,
};

export const fetchCustomers = createAsyncThunk<Customer[], void, { rejectValue: string }>(
  "customers/fetchCustomers",
  async (_, { rejectWithValue }) => {
    try {
      return await getCustomersApi();
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch customers");
    }
  },
);

const customerSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    clearCustomersError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action: PayloadAction<Customer[]>) => {
        state.loading = false;
        state.customers = action.payload;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers";
      });
  },
});

export const { clearCustomersError } = customerSlice.actions;
export default customerSlice.reducer;
